import { Fragment, useCallback, useMemo } from "react";
import TopTab from "../Home/components/topTab";
import MobileSearch from "../Search/mobile-search";
import GameCatalog from "../../components/GameCatalog";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import { getPromotionImages } from "../Promotion/PromotionList";
import i18next from "i18next";
import useSubTypeList from "../../hook/useSubTypeList";
import SupplierList from "../../components/GameSelect/SupplierList";
import Carousel from "../../components/Carousel";
import List from "../Promotion/components/LIST";
import useCasinoType from "../../hook/useCasinoType";
import { filterType } from "../../hook/useGameListFilter";
import FavoriteGameCatalog from "../../components/FavoriteGameCatalog";
import LoadingForLiveLayout from "../../components/Loading/LoadingForLiveLayout";

const Live = () => {
  const handleAllGame = useSelector((state) => state.isHandleAllGame); //redux純取值用useSelector就好 不用dispatch
  const loadingStatus = useSelector((state) => state.isLoaderStatus);
  const subList = useSubTypeList();

  //把Redux store 中的 isHandleAllGame 属性，儲存在 handleAllGame 變量中
  const { platform, topGameList, newGameList, categorizedGames } =
    handleAllGame; //從handleAllGame中提取了 platform、gameList 和 gameType 属性。可以在组件中直接使用这些属性，而不必每次都通过handleAllGame 来訪問它们。

  const promotionList = List();

  const casinoType = useCasinoType();

  const location = useLocation();
  const { pathname } = location;

  const lobbyGames = useMemo(() => {
    return filterType({
      gameList: categorizedGames?.Lobby,
      casinoType: casinoType,
    }); //從redux取categorizedGames裡面的Lobby 記得問號防呆
  }, [categorizedGames]);

  // const favoriteGames = filterType({
  //   gameList: categorizedGames?.MyFavorite,
  //   casinoType: casinoType,
  // });

  const subGames = useMemo(() => {
    return subList?.map((subType, index) => {
      const subGamelist = filterType({
        gameList: categorizedGames[subType],
        casinoType: casinoType,
      });
      return (
        subGamelist?.length > 10 && (
          <>
            <GameCatalog
              list={subGamelist}
              wrapperClassName={subGamelist?.length === 0 && "hidden"}
              mainTitle={subType}
              typeTitle={``}
              observeFalse={index == 0}
            />
            {index === 4 && (
              <section className="px-common-padding-x mb-[20px]">
                <SupplierList
                  LIST={platform}
                  customNavigate="/casino/category/"
                />
              </section>
            )}
          </>
        )
      );
    });
  }, [categorizedGames, subList]);

  return (
    <Fragment>
      <section className="md:hidden">
        <TopTab />
      </section>
      <section className="py-common-padding-y">
        {/* <section className="px-common-padding-y">
          <Carousel />
        </section> */}
      </section>
      <section className="md:hidden">
        <MobileSearch />
      </section>
      <section>
        {/* <GameCatalog
          list={favoriteGames}
          wrapperClassName={favoriteGames?.length === 0 && "hidden"}
          mainTitle={"MyFavorite"}
          typeTitle={``}
          observeFalse
        /> */}

        {loadingStatus ? (
          <LoadingForLiveLayout itemClass="md:!h-[300px] h-[180px]" />
        ) : (
          <GameCatalog
            hiddenButtonNavigator
            list={lobbyGames}
            mainTitle={"Lobby"}
            typeTitle={``}
            itemClass="md:!h-[300px] h-[180px]"
            observeFalse
            swiperProps={{
              delay: 1,
              speed: 25000,
              swiperClassName: "custom-swiper-wrapper",
              customPerView: "live-layout",
            }}
          />
        )}
        <GameCatalog
          observeFalse
          list={[...promotionList]}
          listType="promotion"
          mainTitle={"Promotions"}
          typeTitle={``}
          itemClass="!h-[250px]"
          swiperProps={{
            delay: 1,
            speed: 25000,
            swiperClassName: "custom-swiper-wrapper",
            customPerView: "promotion-layout",
          }}
        />
      </section>
      <section>{subGames}</section>
    </Fragment>
  );
};

export default Live;
